import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { imageBaseApi } from "../../../utilis/imageHelper";
import ChannelService from "../../../services/KangarooServices/Intelligence/ChannelService";
import toast from "react-hot-toast";
import MediaModal from "../../../Kangaroo/PagesSection/Component/MediaModal";
import Select from "react-select";
import DestinationService from "../../../services/KangarooServices/DestinationService";

const ChannelForm = ({ isOpen, toggle, selectedItem, fetchData }) => {
  console.log("🚀 ~ ChannelForm ~ selectedItem:", selectedItem);
  const [institutedata, setInstituteData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isMediaOpen, setIsMediaOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const toggleMedia = () => setIsMediaOpen(!isMediaOpen);

  const fetchUniversityData = async () => {
    setLoading(true);
    try {
      const response = await DestinationService.getList();
      setInstituteData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUniversityData();
  }, []);
  const formik = useFormik({
    initialValues: {
      id: selectedItem?.id,
      name: selectedItem?.name || "",
      logoId: selectedItem?.logoId,
      logoMedia: selectedItem?.logo?.url,
      orderIndex: selectedItem?.orderIndex || "",
      isUnassignedPartner: selectedItem?.isUnassignedPartner || false,
      destinationCountryId: selectedItem?.destinationCountryId
        ? String(selectedItem.destinationCountryId)
        : null,
    },

    enableReinitialize: true,
    onSubmit: async (values) => {
  try {
    const payload = {
      name: values.name,
      orderIndex: values.orderIndex,
      destinationCountryId: values.destinationCountryId,
      isUnassignedPartner: values.isUnassignedPartner,
    };

    // Only add logoId if media exists
    if (selectedMedia?.id) {
      payload.logoId = selectedMedia.id;
    }

    if (values.id) {
      await ChannelService.update(values.id, payload);
      toast.success("Channel partners updated successfully");
    } else {
      await ChannelService.create(payload);
      toast.success("Channel partners created successfully");
    }

    fetchData();
    toggle();
  } catch (error) {
    toast.error("Something went wrong!");
  }
}
  });

  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
      setSelectedMedia(null);
    }
  }, [isOpen]);

  const instituteOptions = institutedata.map((i) => ({
    value: String(i.id),
    label: i.name,
  }));

  useEffect(() => {
    if (selectedItem?.logo) {
      setSelectedMedia({
        id: selectedItem.logo.id,
        url: selectedItem.logo.url,
        name: selectedItem.logo.fileName,
      });
    }
  }, [selectedItem]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Channel partner form</ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <Label>Destination</Label>
            <Select
              options={instituteOptions}
              value={
                instituteOptions.find(
                  (opt) => opt.value === formik.values.destinationCountryId,
                ) || null
              }
              onChange={(selected) =>
                formik.setFieldValue(
                  "destinationCountryId",
                  selected ? selected.value : null,
                )
              }
              placeholder="Select destination country"
              isDisabled={selectedItem?.id}
            />
          </div>
          <FormGroup>
            <Label>Name</Label>
            <Input
              type="text"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.name && !!formik.errors.name}
            />
            <FormFeedback>{formik.errors.name}</FormFeedback>
          </FormGroup>
          <FormGroup>
            <Label>Order Index</Label>
            <Input
              type="number"
              name="orderIndex"
              value={formik.values.orderIndex}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.orderIndex && !!formik.errors.orderIndex}
            />
            <FormFeedback>{formik.errors.orderIndex}</FormFeedback>
          </FormGroup>
          <FormGroup className="d-flex justify-content-between">
            <Label>Is Unassigned Partner?</Label>
            <Input
              type="checkbox"
              checked={formik.values.isUnassignedPartner}
              onChange={(e) =>
                formik.setFieldValue("isUnassignedPartner", e.target.checked)
              }
            />
          </FormGroup>
          <FormGroup>
            <Label style={{ cursor: "pointer" }}>Logo Media</Label>
            {selectedMedia ? (
              <div className="text-center p-3 border rounded shadow-sm bg-light">
                {/* Image Preview */}
                <div
                  style={{
                    maxHeight: "220px",
                    overflow: "hidden",
                    borderRadius: "10px",
                    border: "1px solid #ddd",
                  }}
                  className="mb-3"
                >
                  <img
                    src={`${imageBaseApi}${selectedMedia?.url}`}
                    alt="Featured"
                    style={{ width: "100%", objectFit: "cover" }}
                    className="img-fluid hover-zoom"
                  />
                </div>

                {/* Image Info */}
                <div className="mb-2">
                  <div className="fw-semibold">
                    {selectedMedia.name || "Featured Image"}
                  </div>

                  {selectedMedia.size && (
                    <small className="text-muted">
                      Size: {(selectedMedia.size / 1024).toFixed(1)} KB
                    </small>
                  )}
                </div>

                {/* Buttons */}
                <div className="d-flex gap-2 justify-content-center">
                  <Button
                    size="sm"
                    outline
                    color="primary"
                    className="rounded-pill px-3"
                    onClick={toggleMedia}
                  >
                    Change
                  </Button>

                  <Button
                    size="sm"
                    outline
                    color="danger"
                    className="rounded-pill px-3"
                    onClick={() => {
                      // formik.setFieldValue("featuredMediaId", "");
                      setSelectedMedia(null);
                      formik.setFieldValue("logoMedia", null);
                      formik.setFieldValue("logoId", null);
                    }}
                  >
                    <i className="ri-delete-bin-5-line me-1"></i>
                    Remove
                  </Button>
                </div>
              </div>
            ) : (
              <div className="p-4 border rounded text-center bg-light">
                <i className="ri-image-add-line fs-1 text-secondary"></i>
                <h6 className="mt-2 mb-2 text-muted">No image selected</h6>
                <h6 className="mb-3 text-muted">1200 x 630</h6>
                <Button
                  outline
                  color="secondary"
                  className="rounded-pill px-4"
                  onClick={toggleMedia}
                >
                  <i className="ri-image-add-line me-1"></i> Choose Featured
                  Image
                </Button>
              </div>
            )}
          </FormGroup>
          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {selectedItem?.id ? "Update" : "Create"}
            </button>
            <button type="button" className="btn btn-danger" onClick={toggle}>
              Cancel
            </button>
          </div>
        </form>
      </ModalBody>

      <MediaModal
        isOpen={isMediaOpen}
        toggle={toggleMedia}
        selectedMedia={selectedMedia}
        setSelectedMedia={setSelectedMedia}
      />
    </Modal>
  );
};

export default ChannelForm;
